import { useSitePhone } from 'hooks/useSitePhone'

export const SitePhone = (props) => {
  const [sitePhone, sitePhoneLink] = useSitePhone()

  return (
    <a href={sitePhoneLink} {...props}>
      {sitePhone}
    </a>
  )
}
